import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setShowCustomize } from "../../redux/reducers/threekitSlice";
import FeatureSwitches from "../../../../config/FeatureSwitches";
import { device } from "../../../../utils/breakPoints";
import { useSelector } from "react-redux";

export default function FabricControlsCustomizeButton() {
  const dispatch = useDispatch();
  const featureSwitch = new FeatureSwitches();
  const features = featureSwitch.setFeatures();
  const { addToCartDisabled } = useSelector((state) => ({
    ...state.threekit,
  }));

  return (
    <>
      {features.customizeImage && (
        <AddTextButton
          onClick={() => dispatch(setShowCustomize(true))}
          disabled={addToCartDisabled}
        >
          Add Text
        </AddTextButton>
      )}
    </>
  );
}

const AddTextButton = styled.button`
  text-align: center;
  width: 98px;
  height: 40px;
  background: #02455d;
  font-size: 16px;
  padding: 10px 12px;
  border: none;
  color: white;
  margin-left: 1em;
  @media ${device.mobileLg} {
    margin-top: 12px;
  }
  :disabled,
  [disabled] {
    opacity: 0.7;
    cursor: no-drop !important;
  }
`;
